"use client";

import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import React, { useState } from "react";

import { toast } from "react-toastify";
import Toast from "../../(components)/Toast";
import { Form } from "./(components)/Form";
import { FrameBody } from "../(components)/FrameBody";
import { useYupValidationResolver } from "../(utils)/useYupValidationResolver";
import { validationSchema } from "./(utils)/validationSchema";
import { createIntlPath } from "../../(utils)/createIntlPath";
import { useTranslation } from "../../../i18n/client";
import axiosInstance from "../../../../utils/axios";

const SignIn = ({ params }: any) => {
  const { lng } = params;
  const { t }: { t: any } = useTranslation(lng, "auth");

  const [loading, setLoading] = useState<any>(false);
  const router = useRouter();
  const resolver = useYupValidationResolver(validationSchema);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver,
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const getUser = async (data: any) => {
    return axiosInstance.post("api/transporter/auth/login", data, {
      headers: {
        "Accept-Language": `${
          lng === "en"
            ? "en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7"
            : "de-DE,de;q=0.9,en-US;q=0.8,en;q=0.7"
        } `,
      },
    });
  };

  const { mutate } = useMutation({
    mutationFn: getUser,
    onSuccess: (res) => {
      localStorage.setItem(
        "authTokens",
        JSON.stringify({
          access_token: res?.data?.data?.token?.access_token,
          token_type: "bearer",
        }),
      );
      const lastPath = localStorage.getItem("lastPath");
      if (lastPath) {
        localStorage.removeItem("lastPath");
        router.push(lastPath);
      } else {
        router.push(createIntlPath("/dashboard"));
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
    onError: (error: any) => {
      setLoading(false);
      toast.error(`${error.response.data.message}`);
    },
  });
  const onSubmit = async (data: any) => {
    // todo: submit data
    setLoading(true);
    const formData: any = new FormData();
    formData.append("email", data?.email);
    formData.append("password", data?.password);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mutate(formData));
      }, 1000);
    });
  };

  return (
    <>
      <Toast />
      <FrameBody mainText={t("sign_in_form")} t={t}>
        <Form
          t={t}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          errors={errors}
          register={register}
          isSubmitting={loading}
        />
      </FrameBody>
    </>
  );
};

export default SignIn;
